import "./dataset.f56cc6d6.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefddd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefddd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2YFJl = parcelRequire("2YFJl");

var $8RAYl = parcelRequire("8RAYl");

var $aNTv2 = parcelRequire("aNTv2");

var $cXHfx = parcelRequire("cXHfx");

var $axctD = parcelRequire("axctD");

var $eR6SU = parcelRequire("eR6SU");

var $jDulA = parcelRequire("jDulA");
// ====================================explanstion==============================================
let $298ff57f1f10c094$var$explanations = {
    "page1_sec1_title": "\u4F9D (\u591A\u503C) \u5F8C\u8A2D\u8CC7\u6599\u6B04\u4F4D\uFF0C\u7D71\u8A08\u8CC7\u6599\u96C6\u6240\u64C1\u6709\u8A72\u6B04\u4F4D\u7684\u9805\u76EE\u6578\u91CF\u3002\u5176\u4E2D\u76D2\u9B1A\u5716\u7684\u6700\u5927\u503C\u8207\u6700\u5C0F\u503C\uFF0C\u4EE5 Q3 + 1.5 x IQR \u8207 Q1 - 1.5 x IQR (IQR: \u56DB\u5206\u4F4D\u8DDD) \u8A08\u7B97\u3002",
    "page1_sec2_title": "\u7D71\u8A08\u5404\u5F8C\u8A2D\u8CC7\u6599\u6B04\u4F4D\u9805\u76EE\u88AB\u8CC7\u6599\u96C6\u4F7F\u7528\u7684\u60C5\u5F62\u3002\u4E26\u4EE5\u9577\u689D\u5716\u8207\u5713\u9905\u5716\u5448\u73FE\u64C1\u6709\u6700\u591A\u8CC7\u6599\u96C6\u7684\u524D\u5341\u500B\u9805\u76EE\u3002",
    "page1_sec3_title": "\u7D71\u8A08\u5404\u5F8C\u8A2D\u8CC7\u6599\u6B04\u4F4D\u4E2D\uFF0C\u5404\u9805\u76EE\u5728\u8CC7\u6599\u96C6\u4E2D\u7684\u51FA\u73FE\u983B\u7387\uFF0C\u5448\u73FE\u5404\u9805\u76EE\u4E2D\u983B\u7387\u6700\u9AD8\u8005\u3002\u7D71\u8A08\u5206\u6BCD\u70BA\u6240\u6709\u8CC7\u6599\u96C6\u6578\u91CF\uFF0C\u5206\u5B50\u70BA\u8A72\u9805\u76EE\u7684\u51FA\u73FE\u983B\u7387\u3002\u4F8B\u5982\uFF0C\u4E00\u8CC7\u6599\u96C6\u96D6\u53EF\u80FD\u5305\u542B\u591A\u500B PDF \u985E\u578B\u7684\u8CC7\u6E90\uFF0C\u7136\u53EA\u8981\u51FA\u73FE\u904E\uFF0C\u7121\u8AD6\u6578\u91CF\uFF0C\u5747\u4EE5 1 \u8A08\u6578\u3002",
    "page1_sec4_title": "\u4EE5\u8868\u683C\u5448\u73FE\u6307\u5B9A\u65E5\u671F\u7684\u5404\u5F8C\u8A2D\u8CC7\u6599\u6B04\u4F4D\u503C\u7684\u7D71\u8A08\u72C0\u614B\u3002\u7E3D\u6578\u91CF\u70BA\u8A72\u5F8C\u8A2D\u8CC7\u6599\u6B04\u4F4D\u9805\u76EE\u51FA\u73FE\u65BC\u591A\u5C11\u500B\u8CC7\u6599\u96C6\u3002"
};
let $298ff57f1f10c094$var$stats_data;
let $298ff57f1f10c094$var$daily_fetch_data;
let $298ff57f1f10c094$var$num_dataset;
// ====================================main======================================================
(async ()=>{
    try {
        await window.i18nReady;
        $('#languageSwitcher').on('change', function() {
            const selectedLang = $(this).val();
            (0, $8RAYl.default).changeLanguage(selectedLang, function(err, t) {
                // Update dataTables
                update_table(cur_table_tab.id, date_picker.value, $aNTv2.table_column_mapping);
                // Update labels for histogram
                const x_hist_label = document.querySelector('#dataset_hist text.hist_x_title');
                cur_hist_tab = document.querySelector('#num_tabs li button.active');
                each_hist_label = (0, $8RAYl.default).t("num_of");
                item_hist_label = cur_hist_tab.textContent;
                if (item_hist_label == "Wikidata \u95DC\u9375\u5B57") item_hist_label = " Wikidata \u95DC\u9375\u5B57";
                x_hist_label.textContent = `${each_hist_label}${item_hist_label}`;
                // Update labels for area chart
                const x_label = document.querySelector('#dataset_trend text.area_chart_x_title');
                const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title'); // side bar chart
                cur_tab = document.querySelector('#chart_tabs li button.active');
                each_label = (0, $8RAYl.default).t("each_label");
                item_label = cur_tab.textContent;
                if (item_label == "Wikidata \u95DC\u9375\u5B57") item_label = " Wikidata \u95DC\u9375\u5B57";
                x_label.textContent = `${each_label}${item_label}`;
                x_label_sm.textContent = `${each_label}${item_label}`;
                // remove old popover
                document.querySelectorAll(".info_btn").forEach((el)=>el.remove());
                (0, $axctD.default).info.gen_popover("h5.section_title", $298ff57f1f10c094$var$explanations);
            });
        });
        // Popover
        (0, $axctD.default).info.gen_popover("h5.section_title", $298ff57f1f10c094$var$explanations);
        // Obtain update_time
        const update_time = await (0, $jDulA.default).update_time.get_update_time();
        $cXHfx.update_update_time_display(update_time);
        // Load the Daily Stats Data
        const update_month = update_time.slice(0, 7);
        $298ff57f1f10c094$var$stats_data = await $cXHfx.load_daily_stats_data(update_month);
        // Load the Daily Fetch Data
        $298ff57f1f10c094$var$daily_fetch_data = await (0, $jDulA.default).file.fetch_data_by_date(update_time);
        // Obtain number of dataset
        $298ff57f1f10c094$var$num_dataset = await (0, $jDulA.default).number_of_data.num_of_dataset($298ff57f1f10c094$var$stats_data, 0);
        // ====================================page_elems===============================================
        // Sec#1: Statistics
        const stats_map = $aNTv2.dataset_stats_mapping;
        // Generate Tabs
        (0, $axctD.default).radio.gen_radio_tabs('num_tabs', stats_map);
        const stats_tabs_items = document.querySelectorAll('#num_tabs li button.nav-link');
        const init_tab = document.querySelector('#num_tabs li button#data_type_tab');
        init_tab.classList.add("active"); // init tabs
        // Count Data
        let array_data = (0, $jDulA.default).number_of_data.num_of_obj_and_arr($298ff57f1f10c094$var$daily_fetch_data, 'data_type');
        let mean = (0, $jDulA.default).statistics.mean(array_data);
        let median = (0, $jDulA.default).statistics.median(array_data);
        let mode = (0, $jDulA.default).statistics.mode(array_data);
        (0, $axctD.default).cards.stats_card('mean', "\u5E73\u5747\u6578", mean);
        (0, $axctD.default).cards.stats_card('median', "\u4E2D\u4F4D\u6578", median);
        (0, $axctD.default).cards.stats_card('mode', "\u773E\u6578", mode);
        // Generate Histogram & Box plot
        (0, $eR6SU.default).histogram.gen_hist('dataset_hist', array_data, 500);
        (0, $eR6SU.default).box_plot.gen_box('dataset_box', array_data);
        const x_hist_label = document.querySelector('#dataset_hist text.hist_x_title');
        let cur_hist_tab = document.querySelector('#num_tabs li button.active');
        let each_hist_label = (0, $8RAYl.default).t("num_of");
        let item_hist_label = cur_hist_tab.textContent;
        x_hist_label.textContent = `${each_hist_label}${item_hist_label}`;
        stats_tabs_items.forEach((item)=>{
            item.addEventListener('click', function(event) {
                event.preventDefault();
                let key = item.id.split("_tab")[0];
                if (key == "resources") key = "num_resources";
                // array_data: An array where each element represents the 'count' of the selected 'key' in each dataset.
                array_data = (0, $jDulA.default).number_of_data.num_of_obj_and_arr($298ff57f1f10c094$var$daily_fetch_data, key);
                (0, $eR6SU.default).histogram.update_hist('dataset_hist', array_data, 500);
                (0, $eR6SU.default).box_plot.update_box('dataset_box', array_data);
                // Update x-asix
                const x_hist_label = document.querySelector('#dataset_hist text.hist_x_title');
                let item_hist_label = this.textContent;
                if (item_hist_label == "Wikidata \u95DC\u9375\u5B57") item_hist_label = " Wikidata \u95DC\u9375\u5B57";
                x_hist_label.textContent = `${each_hist_label}${item_hist_label}`;
                update_chart(key, chart_control);
                // Count mean, 
                mean = (0, $jDulA.default).statistics.mean(array_data);
                median = (0, $jDulA.default).statistics.median(array_data);
                mode = (0, $jDulA.default).statistics.mode(array_data);
                (0, $axctD.default).cards.stats_card('mean', "\u5E73\u5747\u6578", mean);
                (0, $axctD.default).cards.stats_card('median', "\u4E2D\u4F4D\u6578", median);
                (0, $axctD.default).cards.stats_card('mode', "\u773E\u6578", mode);
            });
        });
        // ===================================================================================
        // Sec#2: Dataset Trend (Left Side)
        // Generate Tabs
        (0, $axctD.default).radio.gen_radio_tabs('chart_tabs', $aNTv2.dataset_all_mapping);
        const chart_tab_items = document.querySelectorAll('#chart_tabs li button.nav-link');
        const chart_init_tab = document.querySelector('#chart_tabs li button#organizations_tab');
        chart_init_tab.classList.add("active"); // init tabs
        let total_data_trend = await (0, $jDulA.default).number_of_data.top_n_data($298ff57f1f10c094$var$stats_data, $298ff57f1f10c094$var$num_dataset, 'organizations', 'count');
        (0, $eR6SU.default).area_chart.area_chart("dataset_trend", total_data_trend);
        const x_label = document.querySelector('#dataset_trend text.area_chart_x_title');
        let cur_tab = document.querySelector('#chart_tabs li button.active');
        let each_label = (0, $8RAYl.default).t("each_label");
        let item_label = cur_tab.textContent;
        x_label.textContent = `${each_label}${item_label}`;
        chart_tab_items.forEach((item)=>{
            item.addEventListener('click', async function(event) {
                // Click the dropdown
                event.preventDefault();
                // Select Indicator
                const column_name = item.id.split("_tab")[0];
                // Top Data
                total_data_trend = await (0, $jDulA.default).number_of_data.top_n_data($298ff57f1f10c094$var$stats_data, $298ff57f1f10c094$var$num_dataset, column_name, 'count');
                // Update Trend Chart
                (0, $eR6SU.default).area_chart.update_area_chart("dataset_trend", total_data_trend);
            });
        });
        // ===================================================================================
        // Sec#2: Bar & Pie Chart Switch (Right Side)
        async function update_chart(category, chart_btn) {
            let top_data = await (0, $jDulA.default).number_of_data.top_n_data($298ff57f1f10c094$var$stats_data, 10, category, 'count');
            let total_data = await (0, $jDulA.default).number_of_data.top_n_data($298ff57f1f10c094$var$stats_data, $298ff57f1f10c094$var$num_dataset, category, 'count');
            const chart_info = $('.chart_name.col');
            // Show Bar Chart
            if (chart_btn == "bar_btn") {
                // Init
                chart_info.empty().append($('<p>', {
                    class: 'card-sm-num text-center',
                    'data-i18n': 'click-more'
                }));
                chart_info.localize();
                // Update
                (0, $eR6SU.default).bar_chart.update_vertical_bar_chart(top_data, "top_10_chart", ".chart_name.col");
                const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title');
                let cur_tab = document.querySelector('#chart_tabs li button.active');
                let each_label = (0, $8RAYl.default).t("each_label");
                let item_label = cur_tab.textContent;
                x_label_sm.textContent = `${each_label}${item_label}`;
            } else if (chart_btn == "pie_btn") {
                // Append "Others" (data other than the top 10)
                let other = {
                    "name": "others",
                    "display_name": "\u5176\u4ED6",
                    "count": (0, $jDulA.default).number_of_data.total_count(total_data) - (0, $jDulA.default).number_of_data.total_count(top_data)
                };
                top_data.push(other);
                // Init
                chart_info.empty().append($('<p>', {
                    class: 'card-sm-num text-center',
                    'data-i18n': 'click-more'
                }));
                chart_info.localize();
                // Update
                (0, $eR6SU.default).pie_chart.update_pie_chart(top_data, "top_10_chart", ".chart_name.col");
            }
        }
        // Declare Radio Buttons
        const radios = document.querySelectorAll('input[name="chart_radio"]');
        let chart_control = "bar_btn";
        // Init Data and Bar Chart
        let top_data = await (0, $jDulA.default).number_of_data.top_n_data($298ff57f1f10c094$var$stats_data, 10, 'organizations', 'count');
        (0, $eR6SU.default).bar_chart.vertical_bar_chart(top_data, "top_10_chart", ".chart_name.col");
        const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title');
        x_label_sm.textContent = `${each_label}${item_label}`;
        radios.forEach((radio)=>{
            radio.addEventListener('change', (event)=>{
                event.preventDefault();
                chart_control = event.target.id;
                const cur_tab = document.querySelector('#chart_tabs li button.active');
                const column_name = cur_tab.id.split("_tab")[0];
                update_chart(column_name, chart_control);
            });
        });
        chart_tab_items.forEach((item)=>{
            item.addEventListener('click', async function(event) {
                event.preventDefault();
                const cur_tab = document.querySelector('#chart_tabs li button.active');
                const column_name = cur_tab.id.split("_tab")[0];
                await update_chart(column_name, chart_control);
                const x_label = document.querySelector('#dataset_trend text.area_chart_x_title');
                const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title');
                const each_label = (0, $8RAYl.default).t("each_label");
                let item_label = this.textContent;
                if (item_label == "Wikidata \u95DC\u9375\u5B57") item_label = " Wikidata \u95DC\u9375\u5B57";
                x_label.textContent = `${each_label}${item_label}`;
                x_label_sm.textContent = `${each_label}${item_label}`;
            });
        });
        // ===================================================================================
        // Sec#3: Progress bar (Left Side)
        for(let column in $aNTv2.dataset_all_mapping){
            let count_method = 'count';
            if (column == 'resources_formats') count_method = 'presence';
            (0, $eR6SU.default).progress_bar.generate_progress_bar_div($298ff57f1f10c094$var$stats_data, 'top_data', column, count_method, $aNTv2.top_datasets_mapping);
        }
        // ===================================================================================
        // Sec#3: DataTable
        function update_table(tab_id, date, mapping) {
            const key = tab_id.split("_tab")[0];
            (0, $axctD.default).tables.daily_stats_table("data_table", key, selected_file, date, mapping);
        }
        const data_table_map = $aNTv2.dataset_all_mapping;
        // Generate Tabs
        (0, $axctD.default).radio.gen_radio_tabs('table_tabs', data_table_map);
        const table_tabs_items = document.querySelectorAll('#table_tabs li button.nav-link');
        const init_table_tab = document.querySelector('#table_tabs li button#organizations_tab');
        let cur_table_tab = init_table_tab;
        cur_table_tab.classList.add("active"); // init tabs
        // Create DataTable (Init)
        (0, $axctD.default).tables.daily_stats_table("data_table", "organizations", $298ff57f1f10c094$var$stats_data, update_time, $aNTv2.table_column_mapping);
        // Select File Date
        const date_picker = document.getElementById('file_date');
        date_picker.value = update_time; // Init Date Picker Value
        let selected_file = $298ff57f1f10c094$var$stats_data; // Init Data File
        date_picker.addEventListener('change', async (e)=>{
            try {
                let selected_date = e.target.value;
                const folder_name = selected_date.slice(0, 7);
                if (folder_name != update_time.slice(0, 7)) {
                    const filepath = `dataset/stats_data/${folder_name}/${folder_name}.csv`;
                    selected_file = await $2YFJl.csv(filepath);
                }
                let date_idx = (0, $axctD.default).tables.daily_stats_table("data_table", "organizations", selected_file, selected_date, $aNTv2.table_column_mapping);
                if (date_idx == -1) {
                    window.alert(`\u{6240}\u{9078}\u{65E5}\u{671F}\u{6C92}\u{6709}\u{53EF}\u{7528}\u{7684}\u{8CC7}\u{6599}
No available data.`);
                    e.target.value = update_time;
                    cur_table_tab.classList.remove("active");
                    cur_table_tab = init_table_tab;
                    cur_table_tab.classList.add("active");
                }
                update_table(cur_table_tab.id, selected_date, $aNTv2.table_column_mapping);
            } catch (error) {
                window.alert("\u8CC7\u6599\u683C\u5F0F\u4E0D\u4F9B\u9810\u89BD\nNo available data.");
                e.target.value = update_time;
                cur_table_tab.classList.remove("active");
                cur_table_tab = init_table_tab;
                cur_table_tab.classList.add("active");
            }
        });
        table_tabs_items.forEach((item)=>{
            item.addEventListener('click', function(event) {
                event.preventDefault();
                cur_table_tab = this;
                update_table(cur_table_tab.id, date_picker.value, $aNTv2.table_column_mapping);
            });
        });
        (0, $axctD.default).spinner.hideSpinner("loadingOverlay");
    } catch (error) {}
})();


//# sourceMappingURL=dataset.954cd9a9.js.map
